<span #animationRoot class="icon" [innerHTML]="iconSvg | async"></span>
